<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import NavItem from './components/NavItem.vue'

const store = useStore()
const isTestPortal = computed(() => store?.getters?.isTestPortal || false)
</script>

<template>
  <div class="app" :class="{ 'is-test-portal': isTestPortal }">
    <div v-if="isTestPortal" class="test-portal-strip" role="alert">
      <div class="test-portal-strip-content">
        <span class="test-portal-tag">TESZT KÖRNYEZET</span>
        <span class="test-portal-desc">A rendszer teszt üzemmódban fut (TEST_PORTAL="TRUE").</span>
      </div>
    </div>
    <NavItem class="nav-bar" />
    <main class="main-content">
      <div class="content-wrapper">
        <router-view :key="$route.matched[0]?.path === '/settings' ? '/settings' : $route.fullPath"></router-view>
      </div>
    </main>
  </div>
</template>

<style scoped>
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--color-background);
}

.test-portal-strip {
  background: linear-gradient(90deg, #d97706, #b45309, #d97706);
  color: #ffffff;
  padding: 6px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1100;
}

.test-portal-strip-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
}

.test-portal-tag {
  background: rgba(255, 255, 255, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 0.72rem;
  letter-spacing: 0.05em;
  font-weight: 700;
  text-transform: uppercase;
}

.test-portal-desc {
  font-size: 0.82rem;
  opacity: 0.95;
}

.nav-bar {
  position: sticky;
  top: 0;
  z-index: 1050;
  box-shadow: var(--shadow-sm);
}

.main-content {
  flex: 1;
  padding: 0;
  background: var(--color-background);
}

.content-wrapper {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 1.5rem 1rem;
  min-height: calc(100vh - 80px);
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 1rem 0.75rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 0.5rem 0.375rem;
  }
}
</style>
